import React, { useState } from 'react'
import Style from './Login.module.css'
import Input from '../../Components/Input/Input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare, faStoreAlt } from '@fortawesome/free-solid-svg-icons'
import Button from '../../Components/Button/Button'
import { faHandshake } from '@fortawesome/free-regular-svg-icons'
import { errorToast } from '../../Utils/Toast/Toast'
import { useHistory } from 'react-router-dom'

const Login = () => {
    const history=useHistory()
    const[phoneNumber,setPhoneNumber]=useState('') 

    const setPhoneNumberHandler=(e)=>{
        e.preventDefault();
        if(phoneNumber==='') errorToast("شماره تماس وارد نشده")
        else{
            history.push('/confirm',phoneNumber)
        }
    }
    return (
        <div className={Style.pageHolder}>
            <div className={Style.ImageHolder}>
                <img src="/Assets/Images/Auth/contract.jpg" alt="barest" />
            </div> 
            <form className={Style.formHolder}>
                <FontAwesomeIcon icon={faStoreAlt} />
                <p>ورود تامین کنندگان</p>
                <Input
                style={{color:"gray"}} 
                inputtype={'text'}  
                placeholder="شماره همراه خودرا وارد کنید..." 
                type={'tel'}
                value={phoneNumber}
                onChange={e=>setPhoneNumber(e.target.value)}
                maxLength='11' 
                />
                <div className={Style.BtnHolder}>
                    <Button Value={'ارسال'} ClassBtn={'confirmBtn'} ClickHandler={setPhoneNumberHandler}/>
                </div>
            </form>
            <div className={Style.teleportPart}>
                <a href={'/requestforsupplier'}>ثبت نام برای شروع همکاری <FontAwesomeIcon icon={faHandshake}/></a>
                <hr />
                <a href={'https://www.barest.ir'}>انتقال به سایت اصلی <FontAwesomeIcon icon={faShare}/></a>
            </div>
        </div>
    )
}

export default Login
